import axiosInstance from "./axiosInstance";

export const fetchLink = async (): Promise<string | null> => {
  const response = await axiosInstance.get("/link");
  const data = response.data;

  if (!data || Object.keys(data).length === 0) {
    return null;
  }

  return data.link || null;
};

export const createLink = async (link: string) => {
  const response = await axiosInstance.post("/link/create", null, {
    params: { link },
  });
  return response.data;
};

export const deleteLink = async () => {
  await axiosInstance.delete("/link");
};

export const updateLink = async (link: string) => {
  await deleteLink();
  await createLink(link);
};
